// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient-module__BreadBottom__18n0o","BreadTop":"BurgerIngredient-module__BreadTop__2YjRJ","Seeds1":"BurgerIngredient-module__Seeds1__FAsOX","Seeds2":"BurgerIngredient-module__Seeds2__3ur5K","Meat":"BurgerIngredient-module__Meat__161FY","Cheese":"BurgerIngredient-module__Cheese__t6igE","Salad":"BurgerIngredient-module__Salad__xgv-C","Chicken":"BurgerIngredient-module__Chicken__3ukpy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.module.css
// module id = 107
// module chunks = 0